import { useSelector } from 'react-redux';
import { selectCurrentOrg } from '../../../_features/auth/state/selectors';

export const useUserInfo = () => {
  const { user } = useSelector((state) => state.auth);
  const currentOrg = useSelector(selectCurrentOrg);

  return { user, designation: currentOrg?.designation ?? null };
};
